import {
  DashboardOutlined,
  NotificationOutlined,
  ProfileOutlined,
  SettingOutlined,
  SolutionOutlined,
  ThunderboltOutlined,
  UserOutlined
} from '@ant-design/icons';
import { routes } from './routes';

export const listMenuSider = [
  {
    key: routes.home,
    icon: <DashboardOutlined />,
    label: 'Tổng quan'
  },
  {
    key: routes.matches,
    icon: <NotificationOutlined />,
    label: 'Quản lý trận đấu'
  },
  {
    key: routes.prediction,
    icon: <ThunderboltOutlined />,
    label: 'Quản lý dự đoán'
  },
  {
    key: routes.predictionResult,
    icon: <ProfileOutlined />,
    label: 'Kết quả dự đoán'
  },
  // {
  //   key: routes.teams,
  //   icon: <ProfileOutlined />,
  //   label: 'WC-QL đội tuyển'
  // },
  // {
  //   key: routes.players,
  //   icon: <ProfileOutlined />,
  //   label: 'WC-QL cầu thủ'
  // },
  {
    key: routes.wc2026Teams,
    icon: <ProfileOutlined />,
    label: 'DĐWC-Đội tuyển'
  },
  {
    key: routes.wc2026Players,
    icon: <ProfileOutlined />,
    label: 'DĐWC-Cầu thủ'
  },
  {
    key: routes.wc2026Results,
    icon: <ProfileOutlined />,
    label: 'WC2026-Kết quả'
  },

  {
    key: routes.settings,
    icon: <SettingOutlined />,
    label: 'Cài đặt'
  },
  {
    key: routes.users,
    icon: <UserOutlined />,
    label: 'Quản lý người dùng'
  },
  {
    key: routes.whitelist,
    icon: <SolutionOutlined />,
    label: 'IP Whitelist'
  }
];

export const pRoute = {
  [routes.home]: routes.home,
  [routes.matches]: routes.matches,
  [routes.prediction]: routes.prediction,
  [routes.predictionResult]: routes.predictionResult,
  [routes.teams]: routes.teams,
  [routes.players]: routes.players,
  [routes.wc2026Teams]: routes.wc2026Teams,
  [routes.wc2026Players]: routes.wc2026Players,
  [routes.wc2026Results]: routes.wc2026Results,
  [routes.settings]: routes.settings,
  [routes.whitelist]: routes.whitelist,
  [routes.lotteries]: routes.lotteries,
  [routes.lotteryPredictions]: routes.lotteryPredictions
};

export const pOpenKeys = {
  [routes.companies]: 'companies',
  [routes.departments]: 'companies',
  [routes.groups]: 'companies'
};
